import React from 'react';
import { Handle, Position } from 'reactflow';

const operatorOptions = [
  { value: 'and', label: 'AND' },
  { value: 'or', label: 'OR' },
];

export default function LogicNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #f97316',
      background: 'var(--card)',
      minWidth: 150,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <Handle type="target" position={Position.Left} id="input" style={{ top: '50%', background: '#f97316' }} />
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f97316' }}>
        Logic Gate
      </div>
      <select
        value={data.operator || 'and'}
        onChange={(e) => onChange('operator', e.target.value)}
        style={{
          width: '100%',
          padding: '4px 6px',
          borderRadius: 4,
          border: '1px solid var(--border)',
          background: 'var(--surface)',
          color: 'var(--text)',
          fontSize: 13,
        }}
      >
        {operatorOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 6 }}>
        Connect 2+ condition/logic inputs
      </div>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#f97316' }} />
    </div>
  );
}
